module.exports = __webpack_public_path__ + "static/media/30OIOS8.2ae93789.jpg";